import { createGlobalStyle } from 'styled-components';

import 'react-toastify/dist/ReactToastify.css';

export default createGlobalStyle`
* {
  margin: 0;
  padding: 0;
  outline: 0;
  box-sizing: border-box;
}

::-webkit-scrollbar{
  display: none;
}

img{
  user-select: none;
	-webkit-user-drag: none;
	-webkit-app-region: no-drag;
	cursor: default;

  &::after, &::before {
    user-select: none;
    -webkit-user-drag: none;
    -webkit-app-region: no-drag;
    cursor: default;
  }
}

html, body, #root {
  max-width: 100%;
  overflow-x: hidden;
}


body {
 background: #100f12;
 color: #fff;
 -webkit-font-smoothing: antialiased;
 overflow-x: hidden;
}

body, input, button {
 font-size: 16px;
 font-family: 'Avenir Next LT Pro Regular', Helvetica, sans-serif;
}

span {
  font-family: 'Avenir Next LT Pro Bold';
  color: #5EEDDC;
}

p {
  color: #aaa;
}

button {
 cursor: pointer;
}

.button{
  color: #fff;
  text-decoration: none;
  padding: 5px 24px;
  border: 2px solid #fff;
  border-radius: 25px;
  width: fit-content;
  transition: all 0.2s;
  font-weight: 600;

  &:hover{
    background-color: #5EEDDC;
    border-color: #5EEDDC;
    color: #100f12;
  }
}

.fade-appear,
.fade-enter {
    opacity: 0;
    z-index: 1;
}
.fade-appear-active,
.fade-enter.fade-enter-active {
    opacity: 1;
    transition: opacity 300ms linear 150ms;
}

.fade-exit {
    opacity: 1;
}

.fade-exit.fade-exit-active {
    opacity: 0;
    transition: opacity 150ms linear;
}

.fade-modal-enter{
   opacity: 0;
}
.fade-modal-exit{
   opacity: 1;
}
.fade-modal-enter-active{
   opacity: 1;
}
.fade-modal-exit-active{
   opacity: 0;
}
.fade-modal-enter-active,
.fade-modal-exit-active{
   transition: opacity 500ms;
}
`;
